import type { NavigationPermission } from "@/config/navigation/types";
import type { ElementType, ReactNode } from "react";

export type DetailPermission = NavigationPermission;

export interface DetailTab {
  id: string;
  label: string;
  icon?: ElementType;
  permission?: DetailPermission;
  content: ReactNode | (() => ReactNode);
}

export interface DetailAction {
  id: string;
  label: string;
  icon?: ElementType;
  onClick: () => void;
  permission?: DetailPermission;
  destructive?: boolean;
  menuOnly?: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

export function renderTabContent(tab: DetailTab): ReactNode {
  return typeof tab.content === "function" ? tab.content() : tab.content;
}
